import {createApp} from 'vue'
import TilmeldProfilKvittering from './TilmeldProfilKvittering'

const el = '.kb-component--tilmeld-profil-kvittering'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((TilmeldProfilKvitteringDOM)=>{
            const component = createApp(TilmeldProfilKvittering).use(Store)
            component.mount(TilmeldProfilKvitteringDOM)
        })
    }
}